/**
 * @file 入口
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */
import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import DeveloperCommunity from './DeveloperCommunity';

const CommunityRouter = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/developercommunity" component={DeveloperCommunity} />
            </Switch>
        </BrowserRouter>
    );
};

export default CommunityRouter;